import Vue from 'vue'
import validate from 'mixins/validate'
import passwordsCheck from 'mixins/passwords-check'

Vue.component('account-register-form', {
  data () {
    return {
    }
  },
  mixins: [validate, passwordsCheck],
  methods: {
    submitForm (e) {
      let isValid = this.validateAndDisplayErrors(e)
      const confirmPassword = this.$refs.confirmPassword

      if (!this.checkPasswords) {
        isValid = false
        confirmPassword.isValid = false
      }

      if (!isValid) {
        e.preventDefault()
      }
    }
  }
})
